export default {"src":"/_next/static/media/close.9d0c8a9a.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};